// @ts-check
import { th } from "intl-tel-input/i18n";
export class PbUtils{
/**
 * 
 * @param {any} main 
 */
constructor(main){
this.m = this.main = main;
this.alignClasz = ['text-start','text-center','text-end'];
this.alignDirection = ['Left','Center','Right'];
this.flexAlignClasz = ['justify-content-start','justify-content-center','justify-content-end'];
//
this.sizeClasz = ['fs-6','fs-4','fs-1'];
this.buttonSizeClasz = ['btn-sm','btn-md','btn-lg'];

// this.svgModules = import.meta.glob('/node_modules/bootstrap-icons/icons/*.svg', { 
//   query: '?raw', 
//   import: 'default' 
// });

this.svgSprite = import.meta.glob('/node_modules/bootstrap-icons/bootstrap-icons.svg', { 
  query: '?raw', 
  import: 'default' 
});

this.ICON_CACHE = {};
//
}
/**
 * 
 * @param {string} selector 
 * @returns 
 */
query(selector){
return document.querySelector(selector);
}//
/**
 * 
 * @param {string} selector 
 * @returns 
 */
queryAll(selector){
return document.querySelectorAll(selector);
}//
/**
 * 
 * @param {string} tag 
 * @param  {string[]} clasz 
 * @param  {string} text
 * @param  {any[]} attr
 * @returns 
 */
createElement(tag,clasz=[],text='',attr=[]){
let el = document.createElement(tag);
if(text){
  el.textContent = text;
}
el.classList.add(...clasz);
if(el.classList.length==0){
  //because created element without class still have class = ""
  el.removeAttribute('class');
}
if(attr.length>0){
  this.setAttribute(el,attr);
}
return el;
}//


async ce2(...arr){
let result;
//check if the last element is any array, if not remove it, use at options
let options;
let lastArr = arr[arr.length - 1];
if(this.m.utils.isObjectLiteral(lastArr)){
options = arr.pop();
}

//arr.reverse();
let arr1 = arr.shift();
if(!arr1){return;}
let container = this.createElement(arr1[0],arr1[1],'',arr1[3]);
this.addClass(container,['sp']);
let el;
for(let ar of arr){
if(['a','button','h3'].includes(ar[0])){
if(ar[3]){
let icon;
    for(let a of ar[3]){
      if(a.n=='ic'){
        icon=a.v;
        break;
        //dont add the testContent, add as span
      }
    }
    if(icon){
      el = this.createElement(ar[0],ar[1],'',ar[3]);
      if(typeof icon === 'string'){
        this.appendChild(el,await this.getSvg(icon),`<span>${ar[2]}</span>`);
      }else{
        this.appendChild(el,await this.getSvg(icon.name,icon.data),`<span>${ar[2]}</span>`);
      }
     
    }else{
      el = this.createElement(ar[0],ar[1],ar[2],ar[3]);
    }

  }
}else{
el = this.createElement(ar[0],ar[1],ar[2],ar[3]);
}

container.appendChild(el);
container = el;
}
if(el){
result = el.closest('.sp');
}else{
  result = container;
}
this.main.log(result);
//temp

let serialize = true;
if(options){
  if(options.serialize==false){
  serialize = false;
}
}


return (serialize)? result.outerHTML : result;

}//

async ce(...arr){
if(arr.length==1){
  return this.createElement(arr[0][0],arr[0][1],arr[0][2],arr[0][3]);
}

let result;
let options;
let lastArr = arr[arr.length - 1];

// if(arr.length==2 && this.m.utils.isObjectLiteral(lastArr)){
// result = this.createElement(arr[0][0],arr[0][1],arr[0][2],arr[0][3]);
// options = lastArr;
// }

  //every other situation
if(this.m.utils.isObjectLiteral(lastArr)){
//check if the last element is any array, if not remove it, use at options
options = arr.pop();
}
// let arr1 = arr.shift();
// //if(!arr1){return;}
//temp
let container = this.createElement('div',['sp']);
let el;
for(let ar of arr){
if(['a','button','h3'].includes(ar[0])){
if(ar[3]){
let icon;
    for(let a of ar[3]){
      if(a.n=='ic'){
        icon=a.v;
        break;
        //dont add the testContent, add as span
      }
    }
    if(icon){
      el = this.createElement(ar[0],ar[1],'',ar[3]);
      if(typeof icon === 'string'){
        this.appendChild(el,await this.getSvg(icon),`<span>${ar[2]}</span>`);
      }else{
        this.appendChild(el,await this.getSvg(icon.name,icon.data),`<span>${ar[2]}</span>`);
      }
     
    }else{
      el = this.createElement(ar[0],ar[1],ar[2],ar[3]);
    }

  }
}else{
el = this.createElement(ar[0],ar[1],ar[2],ar[3]);
}
container.appendChild(el);
container = el;
}

if(el){
result = el.closest('.sp').firstElementChild;
}else{
  result = container.firstElementChild;
}
this.main.log(result);
//temp
let serialize = true;
if(options){
  if(options.serialize==false){
  serialize = false;
}
}
return (serialize)? result.outerHTML : result;
}//

/**
 * 
 * @param {string} text 
 * @returns 
 */
createText(text){
return document.createTextNode(text);
}//func
/**
 * 
 * @param {any} data 
 * @returns 
 */
async createButton(data){
  let {title='Learn More',href='',size='md',align='left',color='primary',icon='',cb=null,isWidget=false,isView=false,isSocial=false,clasz=[],divClasz=[]
  } = data;
  let div = this.createElement('div',['d-flex']);
  div.contentEditable = false;
  div.innerHTML = 
  `
  <a class="sp-cm ${this.showIf(!isView)}" style="cursor: pointer;">${await this.main.pbu.getSvg('three-dots-vertical')}</a>
  <a type="button" ${this.main.pbu.setAttributeIf(size!='md',[{n:"si",v:size}])} ${this.main.pbu.setAttributeIf(align!='left',[{n:"al",v:align}])} ${this.main.pbu.setAttributeIf(href,[{n:"href",v:href}])}  class="sp-button alignable d-flex align-items-center btn btn-${size} btn-${color}">${await this.main.pbu.getSvg(icon)}<span class="sp-main-text">${this.main.utils.capitalize(title)}</span></a>
  `;
  //data-name : important to save social buttons
  let button = div.querySelector('.sp-button');
  let buttonText = div.querySelector('span.sp-main-text');
  let linkIcon = `<a class="link-icon">${await this.main.pbu.getSvg('link')}</a>`;
if(clasz){
  this.main.pbu.addClass(button,clasz);
}

if(divClasz.length>0){
  this.main.pbu.addClass(div,divClasz);
}

if(isView){
this.addClass(button,['sp-route-link','sp-detail']);
if(cb){
  this.listen(button,'click',(e)=>{
    e.preventDefault();
    cb();
  });
}
}else{
    if(href){
     this.appendChild(div,linkIcon);
    }
    //handle
  let cm = div.querySelector('.sp-cm');
  let settingsTemplate = this.createElement('div');
  settingsTemplate.innerHTML = 
  `
  <div class="sp-basic-settings d-flex"></div>
  <form class="search-post auto-complete position-relative">
  <p>Link</p>
  ${this.createFormControl({serialize:true,placeholder:"Title",value:`${button.querySelector('span.sp-main-text').textContent}`,clasz:['sp-title','sp-validation-required']})}
   ${this.createFormControl({serialize:true,type:"url",placeholder:"Link",value:`${button.href}`,clasz:['sp-link']})}
   <ul class="list-group mt-2 search-post-display position-absolute" style="z-index:1050;cursor:pointer;">
  </ul>
  </form>
  `;

     let titleControl = settingsTemplate.querySelector('.sp-title');
    let linkControl = settingsTemplate.querySelector('.sp-link');
    if(isSocial){
      this.hide(titleControl);
    }

   let basicSettings = settingsTemplate.querySelector('.sp-basic-settings');
    //use cb for now, as saas has not been implemented
    let alignSettings = await this.getDropdown({name:"Align",el:button,attr:'al',items:['Left','Center','Right'],defaultValue:'Left'});

    let sizeSettings = await this.getDropdown({cb:(size)=>{
    //size = size.toLowerCase();
    if(size=='Small'){
      this.addRemoveClass(button,[this.buttonSizeClasz[0]],[this.buttonSizeClasz[1],this.buttonSizeClasz[2]]);
      button.setAttribute('si','sm');
    }else if(size=='Medium'){
      this.addRemoveClass(button,[this.buttonSizeClasz[1]],[this.buttonSizeClasz[0],this.buttonSizeClasz[2]]);
      button.setAttribute('si','md');
    }else if(size=='Large'){
      this.addRemoveClass(button,[this.buttonSizeClasz[2]],[this.buttonSizeClasz[0],this.buttonSizeClasz[1]]);
      button.setAttribute('si','lg');
    }
    },name:'Size',attr:'si',items:['Small','Medium','Large'],defaultValue:'Medium'});

    let iconSettings = await this.getIcons({el:button.querySelector('svg.sp-svg')});

    this.main.pbu.appendChild(basicSettings,alignSettings,sizeSettings,iconSettings);

    if(isSocial){
      let removeButton = await this.getEventButton("Remove",{cb:()=>{
      let mainElement = button.closest('[m=social]');
      let buttons = [...mainElement.querySelectorAll('.sp-button')];
      if(buttons.length==1){
        this.m.utils.notify("Cant Remove",{level:1,customMessageDiv:this.m.modal.notice});
        return;
      }else{
        div.remove();
      }
    },icon:'trash',color:'danger',size:'sm'});
    basicSettings.appendChild(removeButton);
    }


    
  this.listen(cm,'click',async()=>{
    this.m.modal = this.main.utils.setModal('Settings',settingsTemplate);
    //search
    this.main.pbu.listen(linkControl,'input',async()=>{
      //preprocess
    if(!this.main.vu.sanitize([linkControl])){return;}//??
    let regex = new RegExp(`${linkControl.value}`, "i");
    let posts = await this.main.fu.fetch({link:this.main.fu.getApi('/home/posts',[{n:'limit',v:-1}])});
    posts = posts.filter(p=>regex.test(p.title));
    this.main.autoComplete(linkControl,false,posts,'post');
  });//
    

    this.listen(this.m.modal.confirm,'click',()=>{
      //validate title
      if(!this.main.vu.validate(titleControl,linkControl)){
        return;
      }
      buttonText.textContent = titleControl.value;
      //############## link 
      //set if validation passes
      let pathname = (isSocial) ? linkControl.value : linkControl.getAttribute('data-path');
      let hostname = linkControl.getAttribute('data-hostname');
      if(pathname){
        button.href = (hostname=='localhost')? pathname:linkControl.value;
        // button.setAttribute('data-path',pathname);
        // button.setAttribute('data-hostname',);
        button.parentElement.querySelector('a.link-icon')?.remove();
        this.appendChild(button.parentElement,linkIcon);
      }else{
        //link removed
        button.removeAttribute('href');
        button.parentElement.querySelector('a.link-icon')?.remove();
      }
      this.m.modal.dismiss.click();
    });
  });//cm
  }
  return (isView || isWidget)?button:div;
}//func

/**
 * 
 * @param {any} data 
 * @returns 
 */
async getEventButton(title='Save',options={}){
let {size='md',color='primary',icon='',cb=null,clasz=[],style='',keepActive=true} = options;

let div = this.main.pbu.createElement('div');
div.innerHTML = `<button type="button" class="evt-button btn btn-${size} btn-${color}">${await this.main.pbu.getSvg(icon)}${title}</button>`;
let button = div.querySelector('button.evt-button');

if(clasz){
  //this is the button class
  this.main.pbu.addClass(button,clasz);
}

if(style){
  button.style = style;
}


this.main.pbu.listen(button,'click', async ()=>{
if(!keepActive){
this.main.activeSaveButton = button;
button.disabled = true;
} 
//binding issues
if(cb){
cb();
}

});
return button;
}//func


/**
 * 
 * @param {any} data 
 */
async createTable(data){
let section = this.createElement('section');
section.innerHTML = 
`
<div class="table-responsive">
<table class="table table-striped sp-list-table">
  <thead class="sp-th">
  <tr class="sp-tr"><th scope="col"></th></tr>
  </thead>
       <tbody class="mass-action sp-tb">
       </tbody>
     </table>
     <button id="massDeleteButton" class="btn btn-primary d-none"  type="button">Trash</button>
</div>
`;
let tr = section.querySelector('.sp-tr');
let tb = section.querySelector('.sp-tb');
let l = data.titles.length;
let value;

this.appendChild(tr,` <th scope="col">${data.titles[0]}</th>`);
//this.appendChild(tr,` <th scope="col">${data.titles[1]}</th>`);

 for(let i=1;i<l;i++){
    this.appendChild(tr,` <th scope="col">${data.titles[i]}</th>`);
  }

this.appendChild(tr,`<th scope="col">Edit</th>`);
//
for(let p of data.posts){
  let tr = this.createElement('tr',['mass-action-entry']);
  tr.setAttribute('data-id',p.id);
  tb.appendChild(tr);
  this.appendChild(tr,`<td data-label="Delete"><input type = "checkbox" class="form-check-input mass-action-item" data-id="${p.id}"></td>`);
  //NOTE: Element [0] serves as the href title
  this.appendChild(tr,`<td data-label="${data.titles[0]}"><a class="sp-nav-link" target="_blank" href="${p.href}"> ${p.titles[0]}</a> </td>`);
  //this.appendChild(tr,`<td data-label="${data.titles[1]}">${this.main.utils.getIf(p.titles[1],'')}</td>`);
  //
 for(let i=1;i<l;i++){
    value = p.titles[i];
    if(this.m.utils.isNull(value)){
      if(value==0){
      }else{
        value = '';
      }
    }
    this.appendChild(tr,`<td data-label="${data.titles[i]}">${value}</td>`);
  }
  

  this.appendChild(tr,`<td data-label="Modify"><a class="sp-route-link sp-nav-link sp-admin "  href="${p.editHref}">${await this.m.pbu.getSvg('pencil-square')}Edit</a></td>`);
 
  let input = tr.querySelector('input.mass-action-item');
 this.main.dashboard.showTrashButton(input);
}//for
return section;
}//func

/**
 * 
 * @param {any} data 
 */
createTablebk(data){
let section = this.createElement('section');
section.innerHTML = 
`


<div  class="table-responsive">
<table class="table table-striped sp-list-table">
  <thead class="sp-th">
  <tr class="sp-tr"><th scope="col"></th></tr>
  </thead>
       <tbody class="mass-action sp-tb">
       </tbody>
     </table>
     <button id="massDeleteButton" class="btn btn-primary d-none"  type="button">Trash</button>
</div>
`;
let tr = section.querySelector('.sp-tr');
let tb = section.querySelector('.sp-tb');
let l = data.titles.length;
for(let t of data.titles){
this.appendChild(tr,` <th class="d-none d-md-table-cell" scope="col">${t}</th>`);
}
this.appendChild(tr,
`
<th class="d-none d-md-table-cell" scope="col">Edit</th>
`
);
for(let p of data.posts){
  let tr = this.createElement('tr',['mass-action-entry']);
  tr.setAttribute('data-id',p.id);
  tb.appendChild(tr);
  this.appendChild(tr,`<td class="d-none d-md-table-cell"><input type = "checkbox" class="form-check-input mass-action-item" data-id="${p.id}"></td>`);
  //NOTE: Element [0] serves as the href title
  this.appendChild(tr,`<td class="d-none d-md-table-cell"><a class="sp-nav-link" target="_blank" href="${p.href}"> ${p.titles[0]}</a> </td>`);
  for(let i=1;i<l;i++){
    this.appendChild(tr,`<td class="d-none d-md-table-cell">${this.main.utils.getIf(p.titles[i],'')}</td>`);
  }
  this.appendChild(tr,`<td class="d-none d-md-table-cell"><a class="sp-route-link sp-nav-link sp-admin "  href="${p.editHref}" ><i class="bi bi-pencil-square"></i>Edit</a></td>`);
 
  let input = tr.querySelector('input.mass-action-item');
 this.main.dashboard.showTrashButton(input);
}//for
return section;
}//func
/**
 * 
 * @param {any} data 
 * @returns 
 */
createFormControl(data){
let isCheck = data.type=='radio' || data.type=='checkbox';
data.type = (data.type)?data.type:'text';
let row = this.createElement('div',[isCheck?'form-check':'sp-form-control']);
data.id = (data.id)?data.id:`id${this.main.utils.getRandomInt(100)}`;
row.innerHTML =
 `
<label for="${data.id}" class="sp-form-label ${this.addClassIf(isCheck,['form-check-label'],['form-label'])}">${data.title?data.title:''}</label>
<input type="${data.type}" ${(isCheck &&(data.value==true || data.value=='true'))?'checked':''}  class="sp-form-control sp-validation ${this.addClassIf(isCheck,['form-check-input'],['form-control'])} ${data.clasz?.join(' ')}"  id="${data.id}">
 `
let input = row.querySelector('input');
let label = row.querySelector('label');
if(!data.title){label?.remove();}
if(data.labelClasz){
  this.addClass(label,data.labelClasz);
}
if(data.divClasz){
  this.addClass(row,data.divClasz);
}else{
  this.addClass(row,['row','mb-3']);
}

if(data.value){
input.setAttribute('value',data.value);
}

if(data.name){
input.name = data.name;
}

if(data.placeholder){
input.placeholder = data.placeholder;
}
//check
if(data.required){
this.addClass(input,['sp-validation-required']);
}
if(data.withSubmit){
  this.appendChild(row,'<button class="btn btn-primary w-100 my-2 sp-button" type="button">Submit</button>');
}

if(data.serialize){
return (data.inputOnly)?input.outerHTML: row.outerHTML;
 }else{
return (data.inputOnly)?input:row;
 }

}//

/**
 * 
 * @param {any} data 
 * @returns 
 */
createSelectElement(data){
data.id = (data.id)?data.id:`id${this.main.utils.getRandomInt(100)}`;
let row = this.createElement('div');
row.innerHTML =
 `
<label for="${data.id}" class="sp-form-label form-label ${this.showIf(data.title)}">${data.title?data.title:''}</label>
<div class="col-sm-10">
<select id="${data.id}"  class="form-select sp-select">
</select>
</div>
 `;
/**@type {HTMLSelectElement}*/let select = row.querySelector('.sp-select');
let label = row.querySelector('.sp-form-label');

if(data.items){
for(let i of data.items){
let option = `<option ${(i==data.value)?'selected':''}>${i}</option>`;
this.appendChild(select,option);
}
}else if(data.postItems){
if(data.default){
  this.appendChild(select,`<option value=null>${data.default}</option>`);
}
for(let i of data.postItems){
let option = `<option value="${i.id}" ${(i.id==data.value)?'selected':''}>${i.title}</option>`;
this.appendChild(select,option);
}
}

if(data.clasz){
  this.addClass(select,data.clasz);
}
if(data.labelClasz){
  this.addClass(label,data.labelClasz);
}
if(data.divClasz){
  this.addClass(row,data.divClasz);
}else{
  this.addClass(row,['row','mb-3']);
}

if(data.cb || data.el){
  //let controls = row.querySelectorAll('select.sp-select');

    this.main.pbu.listen(select,'change',()=>{
      let selected = select.value;
      this.main.log(selected,'PbUtils.createSelectElement(): selected value');
      if(data.cb){
        data.cb(selected);
      }
      //
    if(data.el){
      let mainElement;
      if (data.el instanceof Element) {
        mainElement = data.el;
      }else{
        mainElement = data.el.parent.querySelector(data.el.elSelector);
      }
      data.elClasz = data.elClasz || [];
        if(selected==data.defaultValue){
          mainElement.removeAttribute(data.attr);
          this.removeClass(mainElement,data.elClasz);
        }else{
          mainElement.setAttribute(data.attr,selected);
          this.addClass(mainElement,data.elClasz);
        }
      }
    });
  
}

if(data.serialize){
  return row.outerHTML;
}else{
return row;
}
}//

/**
 * 
 * @param {any} data 
 */
//name used for id generation
createCheckedInputElement(data){
data.id = (data.id)?data.id:`id${this.main.utils.getRandomInt(100)}`;
data.type = (data.type)?data.type:'checkbox';
let row = this.createElement('div',['row','mb-3']);
row.innerHTML = 
 `
<div class="mb-3 row">
<label for="${data.id}" class="col-sm-2 col-form-label ${this.showIf(data.title)}">${data.title}</label>
<div class="col-sm-10 sp-items" id="${data.id}">
</div>
</div>
 `
//note: all element have same name
//concatenate name to id to enable lable click
let itemsDiv = row.querySelector('.sp-items');
if(data.divClasz){
  this.addClass(row,data.divClasz);
}

for(let i of data.items){
let item = 
`
<div class="form-check">
<input id="${i}-${data.id}" type="${data.type}"  ${this.main.pbu.setAttributeIf((i==data.value)||(data.isBool && this.main.utils.isTrue(data.value)),[{n:"checked",v:"checked"}])} class="form-check-input sp-input ${data.clasz?.join(' ')}"  name="${data.id}" value="${i}">
<label for="${i}-${data.id}" class="form-check-label">${i}</label>
</div>
`;
this.appendChild(itemsDiv,item);
}//for

if(data.cb || data.el){
  let controls = row.querySelectorAll('input.sp-input');
  for(let control of controls){
    this.main.pbu.listen(control,'change',()=>{
      let checked = this.main.utils.getBit(control.checked);
      this.main.log(checked,'PbUtils.createCheckedInputElement(): checked input');
      if(data.cb){
        data.cb(checked);
      }
      
      if(data.el){
      data.elClasz = data.elClasz || [];
        if(checked==data.defaultValue){
          data.el.removeAttribute(data.attr);
          this.removeClass(data.el,data.elClasz);
        }else{
          data.el.setAttribute(data.attr,checked);
          this.addClass(data.el,data.elClasz);
        }
      }
    });
  }
}

if(data.serialize){
  return row.outerHTML;
}else{
return row;
}
}//func

createHr(){
  let div = this.createElement('div',['my-4','w-25','d-block','mx-auto']);
  div.innerHTML = 
  `
  <hr class="sp-hr"/>
  `;
  return div;
}
/**
 * 
 * @param {HTMLElement} parent 
 * @param  {...HTMLElement} els 
 */
appendChild(parent,...els){
for(let el of els){
 if(typeof el=='string'){
  parent.insertAdjacentHTML('beforeend', el);
 }else{
parent.appendChild(el);
 }
}
}//

/**
 * 
 * @param {HTMLElement} parent 
 * @param  {...HTMLElement} els 
 */
appendChildIf(parent,...els){
for(let el of els){
if(!parent.contains(el)){
  this.appendChild(parent,el);
}
}
}//

/**
 * 
 * @param {HTMLElement} parent 
 * @param  {...HTMLElement} els 
 */
prependChild(parent,...els){
for(let el of els){
 if(typeof el=='string'){
  parent.insertAdjacentHTML('afterbegin', el);
 }else{
parent.prepend(el);
 }
}
}//

/**
 * 
 * @param {HTMLElement} el 
 * @param {string} eventType 
 * @param {Function} func 
 * @param {any} component 
 * @param {any[]} cleanupEls - elements to cleanup
 */
listen(el,eventType,func,component,cleanupEls){
 el.addEventListener(eventType,(e)=>{
		func(e);
	},{signal:component?.controler?.signal});
 component?.evtHandlers?.push(func);
 component?.cleanups?.push(()=>{
  el=null;
  if(cleanupEls?.length>0){
    for(let el of cleanupEls){
      el = null;
    }
 }
});
}//

/**
 * 
 * @param {HTMLElement|SVGElement} el 
 * @param {string[]} clasz 
 */
addClass(el,clasz=[]){
for(let c of clasz){
  if(c){
    el.classList.add(c);
  }
}
}//

/**
 * 
 * @param {HTMLElement} el 
 * @param {string[]} add - classes to add
 * @param {string[]} remove - classes to remove
 */
addRemoveClass(el,add,remove){
this.addClass(el,add);
this.removeClass(el,remove);
}//func
/**
 * 
 * @param {HTMLElement} el
 * @param {any[]} attr
 */
setAttribute(el,attr){
for(let a of attr){
  el.setAttribute(a.n,a.v);
}
}//func

/**
 * 
 * @param {HTMLElement} el 
 * @param {string} name 
 */
getAttribute(el,name){
let attr = el.getAttribute(name);
if(!attr){
  attr = '';
}
if(attr==null){
  attr = '';
}
if(attr=='null'){
  attr = '';
}
return attr;
}//func

/**
 * 
 * @param {HTMLElement} el 
 * @param {string} type 
 */
removeAttribute(el,type){
el.removeAttribute(type);
}//func

/**
 * 
 * @param {HTMLElement} el 
 * @param {string[]} clasz 
 */
removeClass(el,clasz=[]){
for(let c of clasz){
  if(c){
el.classList.remove(c);
  }
}
}//
/**
 * 
 * @param {HTMLElement} el 
 * @param {string} oldClass 
 * @param {string|string[]} newClasz 
 */
replaceClass(el,oldClass,newClasz){
el.classList.remove(oldClass);
if(typeof newClasz=='string'){
el.classList.add(newClasz);
}else{
for(let c of newClasz){
el.classList.add(c);
}
}
}//
/**
 * 
 * @param  {...HTMLElement} els 
 */
hide(...els){
for(let el of els){
el.classList.add('d-none');
}

}//
/**
 * 
 * @param  {...HTMLElement} els 
 */
show(...els){
for(let el of els){
el.classList.remove('d-none');
}
}//

/**
 * 
 * @param {boolean|any} condition 
 */
showIf(condition){
if(condition==false || this.main.utils.isNull(condition)){
  return 'd-none'
}else{
  return '';
}
}

/**
 * 
 * @param {boolean} condition - the condition to test
 * @param {string[]} clasz - class to add if true
 * @param {string[]|null} elseClasz - class to add if false (*optional)
 * @returns 
 */
addClassIf(condition,clasz,elseClasz=null){
if(condition){
  return clasz.join(" ")
}else{
  if(elseClasz){
    return elseClasz.join(" ")
  }else{
return '';
  }
  
}
}//

/**
 * 
 * @param {HTMLElement} el 
 */
addActiveClass(el){
let children = el.closest('.sp-active-list').querySelectorAll('.sp-nav-link');
for(let c of children){
this.removeClass(c,['sp-active','active']);
}
this.addClass(el,['sp-active']);
}//
/**
 * this is a template helper methos
 * @param {boolean} condition - the condition to test
 * @param {any[]} attr - attributes to add if true
 * @param {any[]|undefined|null} elseAttr - attributes to add if false (*optional)
 * @returns string
 */
setAttributeIf(condition,attr,elseAttr){
let r = '';
if(condition){
  for(let a of attr){
r = r + `${a.n}="${a.v}" `;
}
}else{
  if(elseAttr){
  for(let a of attr){
r = r + `${a.n}=${a.v} `;
}
  }else{
r= '';
  }
  
}
return r;
}

/**
 * for display only
 * @param {HTMLElement} el 
 */
toggle(el){
if(el.classList.contains('d-none')){
this.show(el);
}else{
this.hide(el);
}
}//
/**
 * 
 * @param {HTMLElement} el 
 * @param {string} clasz 
 */
toggleClass(el,clasz){
if(el.classList.contains(clasz)){
el.classList.remove(clasz);
}else{
el.classList.add(clasz);
}
}//

/**
 * 
 * @param {HTMLElement} parent 
 * @param {HTMLElement|string} child 
 * @param {boolean} showParent
 */
replace(parent,child,showParent=false){
parent.innerHTML = '';
if(typeof child=='string'){
  parent.innerHTML = child;
}else{
parent.appendChild(child);
this.show(child);
}
if(showParent){
  this.show(parent);
}
}//func

/**
 * 
 * @param {HTMLElement} oldChild 
 * @param {HTMLElement|string} newChild 
 */
replaceChild(oldChild,newChild){
if(typeof newChild=='string'){
let tempDiv = this.createElement('div');
tempDiv.innerHTML = newChild;
newChild = tempDiv.firstElementChild;
}
oldChild.parentElement.replaceChild(newChild,oldChild);
}//func
/**
 * 
 * @param {HTMLElement} component 
 * @param {string} type
 */
mount(component,type='body'){
let section;
if(type=='body'){
section = this.query('#replace');
}else if(type=='header'){
section = this.query('#mainHeader');
}else if(type=='footer'){
section = this.query('#mainFooter');
}
this.replace(section,component);
}//

/**
 * 
 * @param {HTMLElement} el 
 */
outerHTML(el){
return el.outerHTML;
}//func

/**
 * 
 * @param {string} name 
 * @param {any} option 
 * @returns 
 */
async getSvgInitial(name,option={}) {
let {width = '1.2em',height = '1.2em',fill = 'currentColor',serialize=true,clasz = []} = option;
if(!name){return `<svg width="${width}" height="${height}" class="sp-svg d-none"></svg>`;}
name = name.trim();
//const spritePath = '/node_modules/bootstrap-icons.svg'; 
//const svgNs = 'http://www.w3.org/2000/svg';
const path = `/node_modules/bootstrap-icons/icons/${name}.svg`; 
try{
let r = await fetch(path);
if(!r.ok){
  throw new Error(`HTTP error! Status: ${r.status}`);
}
let svgString = await r.text(); 
let tempDiv = this.createElement('div');
tempDiv.innerHTML = svgString;
let svg = tempDiv.querySelector('svg');
svg.setAttribute('width', width);
svg.setAttribute('height', height);
svg.setAttribute('fill', fill);
svg.setAttribute('ic', name);
svg.setAttribute('class', `sp-svg bi bi-${name}`);
if(clasz?.length>0){this.addClass(svg,clasz);}
return serialize?svg.outerHTML:svg;
}catch(error){
  this.main.log(error,'PbUtils.getSvg(): error creating svg');
  throw new Error();
}

}//func


/**
 * 
 * @param {string} name 
 * @param {any} option 
 * @returns 
 */
async getSvg2(name,option={}) {
let {width = '1.2em',height = '1.2em',fill = 'currentColor',serialize=true,clasz = []} = option;
if(!name){return `<svg width="${width}" height="${height}" class="sp-svg d-none"></svg>`;}
let tempDiv = this.createElement('div');
let svgString, svg;
// Check cache first
if (this.ICON_CACHE[name]) {
  svgString = this.ICON_CACHE[name];
  tempDiv.innerHTML = svgString;
  svg = tempDiv.querySelector('svg');
//return this.ICON_CACHE[name];
}else{
  try {
  // Bootstrap Icons CDN URL for individual SVGs
const url = `https://cdn.jsdelivr.net/npm/bootstrap-icons@1.13.1/icons/${name}.svg`;
const response = await fetch(url);
if (!response.ok) throw new Error('Icon not found');
svgString = await response.text();
this.ICON_CACHE[name] = svgString;
tempDiv.innerHTML = svgString;
svg = tempDiv.querySelector('svg');
  } catch (error) {
    this.main.log(error,'PbUtils.fetch(): Failed to load icon');
    //return '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/></svg>';
    tempDiv.innerHTML = `<i></i>`;
    svg = tempDiv.querySelector('i');
  }
}

svg.setAttribute('width', width);
svg.setAttribute('height', height);
svg.setAttribute('fill', fill);
svg.setAttribute('ic', name);
svg.setAttribute('class', `sp-svg bi bi-${name}`);
if(clasz?.length>0){this.addClass(svg,clasz);}
  return serialize?svg.outerHTML:svg;
}//

/**
 * 
 * @param {string} name 
 * @param {any} option 
 * @returns 
 */
async getSvg(name,option={}) {
let {width = '16',height = '16',fill = 'currentColor',serialize=true,clasz = []} = option;
if(!name){return `<svg width="${width}" height="${height}" class="sp-svg d-none"></svg>`;}
name = name.toLocaleLowerCase();
let tempDiv = this.createElement('div');
let svgString, svg;
// Check cache first
if (this.ICON_CACHE[name]) {
  svgString = this.ICON_CACHE[name];
  tempDiv.innerHTML = svgString;
  svg = tempDiv.querySelector('svg');
//return this.ICON_CACHE[name];
}else{
  try {
  // Bootstrap Icons CDN URL for individual SVGs
const url = `https://cdn.jsdelivr.net/npm/bootstrap-icons@1.13.1/icons/${name}.svg`;
const response = await fetch(url);
if (!response.ok) throw new Error('Icon not found');
svgString = await response.text();
this.ICON_CACHE[name] = svgString;
tempDiv.innerHTML = svgString;
svg = tempDiv.querySelector('svg');
  } catch (error) {
    this.main.log(error,'PbUtils.fetch(): Failed to load icon');
    //return '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/></svg>';
    tempDiv.innerHTML = `<i></i>`;
    svg = tempDiv.querySelector('i');
  }
}
svg.setAttribute('width', width);
svg.setAttribute('height', height);
svg.setAttribute('fill', fill);
svg.setAttribute('ic', name);
//this class defines a width and height, which makes overidding difficult
this.removeClass(svg,['bi']);
this.addClass(svg,['sp-bi','sp-svg','me-2']);
if(clasz?.length>0){
  this.addClass(svg,clasz);
}

  return serialize?svg.outerHTML:svg;
}//func

/**
 * 
 * @param {any} data 
 * @returns 
 */
async getIcons(data){
let {name='Icon',attr='ic'} = data;
//let temp = ['','','','','','','','','','','','','',''];
let prime = ['brilliance','bullseye','telephone','three-dots-vertical','plus-square-dotted','dash-square-dotted','**'];
let popular = ['heart','star','search','gear','plus','x','check','pencil','trash','download','**'];
let nav = ['house','menu','list','arrow-left','arrow-right','chevron-down','chevron-up','person','cart','envelope','bell','bell','bell','calendar','calendar','clock','**'];
let file = ['folder','file','file-text','file-earmark-text','image','music-note','camera','play','play-btn','file-pdf','file-zip','file-code','**'];
let social = ['chat','share','link','globe','**'];
let tool = ['wrench','wrench-adjustable','lock','unlock','eye','tag','cloud','map','geo-alt','info-circle','**'];
let all = [...prime,...popular,...nav,...file,...social,...tool];


let dropDown = this.main.pbu.createElement('div',['dropdown','sp-dropdown','position-relative']);
dropDown.innerHTML = 
`
  <button class="btn btn-sm btn-primary dropdown-toggle no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">${await this.main.pbu.getSvg('file-plus')}${name}</button>
    <div class="dropdown-menu position-absolute" style="z-index:1050;max-height: 200px; overflow-y: auto;">
    <button type="button" class="dropdown-item" data-icon="none">none</button>
  </div>
`;
//<div class='btn-group sp-btn-group' role='group'></div>
let dropdownMenu = dropDown.querySelector('div.dropdown-menu');
/**@type {string[]}*/ let icons = [];
for(let icon of all){
  icon = icon.trim();
  if(icon=='**'){
    icons.push(icon);
  }else{
    if((!icons.includes(icon))){
      icons.push(icon);
  }
  }
  
}

let bg = this.main.pbu.createElement('div',['btn-group','sp-btn-group']);

for (let key of icons) {
  if(key=='**'){
  this.main.pbu.appendChild(dropdownMenu,bg);
  bg = this.main.pbu.createElement('div',['btn-group','sp-btn-group']);
  
  }else{
    
 this.main.pbu.appendChild(bg,`<button type="button" class="dropdown-item" data-icon="${key}">${await this.main.pbu.getSvg(key)}</button>`
  );
  }
 
}
  //event
  let buttons = dropDown.querySelectorAll('button.dropdown-item');
  let key,newSvg;
  for(let button of buttons){
    this.listen(button,'click',async ()=>{
      key = button.getAttribute('data-icon');
        if(data.cb){
          data.cb(key);
        }
        if(data.el){
          let oldSvg = data.el.querySelector('svg.sp-svg');
      if(key=='none'){
    this.hide(oldSvg);
    oldSvg.removeAttribute(attr);
}else{
    newSvg = await this.main.pbu.getSvg(key,{serialize:false});
    this.replaceChild(oldSvg,newSvg);
    oldSvg = newSvg;
}
        }
      
    });
  }


return dropDown;
}//func

/**
 * 
 * @param {any} data 
 */
async getDropdown2(data){
let {name='',icon='file-plus',attr='data-item',color='outline-secondary',items=[],defaultValue='',clasz=[]} = data;
let dropDown = this.main.pbu.createElement('div',['dropdown','sp-dropdown','position-relative']);
//class="btn btn-lg btn-primary dropdown-toggle no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
dropDown.innerHTML = 
`
  <button class="btn btn-sm btn-${color} dropdown-toggle no-caret m-2" type="button" data-bs-toggle="dropdown" aria-expanded="false">${await this.main.pbu.getSvg(this.main.utils.getIf(icon))}${name}</button>
    <div class="dropdown-menu position-absolute" style="z-index:1050;max-height: 200px; overflow-y: auto;">
  </div>
`;
let dropdownMenu = dropDown.querySelector('div.dropdown-menu');
if(clasz.length>0){
  this.addClass(dropDown,clasz);
}
for(let i of items){
 this.main.pbu.appendChild(dropdownMenu,`<button type="button" class="dropdown-item" ${attr}="${i}">${i}</button>`);
}
  let buttons = dropDown.querySelectorAll('button.dropdown-item');
  let value;
  for(let button of buttons){
    this.main.pbu.listen(button,'click',()=>{
      value = button.getAttribute(attr);
      if(data.cb){
        data.cb(value);
      }
      if(data.el){
        if(value==defaultValue){
          data.el.removeAttribute(attr);
        }else{
          data.el.setAttribute(attr,value.toLowerCase());
        }
        
      }
      
    });
  }

return data.serialize?dropDown.outerHTML:dropDown;
}//func

/**
 * 
 * @param {any} data 
 */
async getDropdown(data){
let {name='',icon='file-plus',attr='data-item',size='md',color='outline-secondary',items=[],defaultValue='',clasz=[]} = data;
let dropDown = this.main.pbu.createElement('div',['dropdown','sp-dropdown']);
//class="btn btn-lg btn-primary dropdown-toggle no-caret" type="button" data-bs-toggle="dropdown" aria-expanded="false">
dropDown.innerHTML = 
`
  <button class="btn btn-${size} btn-${color} dropdown-toggle no-caret m-2" type="button" data-bs-toggle="dropdown" aria-expanded="false">${await this.main.pbu.getSvg(this.main.utils.getIf(icon))}${name}</button>
  <ul class="dropdown-menu ps-2" style="--bs-dropdown-min-width: 100%; width: 100%;">
  </ul>
`;
let dropdownMenu = dropDown.querySelector('ul.dropdown-menu');
if(clasz.length>0){
  this.addClass(dropDown,clasz);
}
for(let i of items){
 this.main.pbu.appendChild(dropdownMenu,`<li><button type="button" class="dropdown-item" ${attr}="${i}">${i}</button></li>`);
}
  let buttons = dropDown.querySelectorAll('button.dropdown-item');
  let value;
  for(let button of buttons){
    this.main.pbu.listen(button,'click',(e)=>{
      e.preventDefault();
      value = button.getAttribute(attr)?.toLowerCase();
      if(data.cb){
        data.cb(value);
      }
      if(data.el){
        if(value==defaultValue){
          data.el.removeAttribute(attr);
        }else{
          data.el.setAttribute(attr,value.toLowerCase());
        }
        
      }
      
    });
  }

return data.serialize?dropDown.outerHTML:dropDown;
}//func

}//class